<div class="flex justify-center mb-10">
	<div class="flex flex-col items-center">
		<div class="flex w-32 h-32">
			<img src="/assets/images/integrations/fct-logo.svg" />
		</div>
		<span
			*ngIf="(currentStep === 0 || state === states.CANCELLED) && !loading"
			class="text-sm text-green underline cursor-pointer mb-3 -mt-5"
			(click)="selectInsuranceProvider()"
			[testHook]="testHooks.SelectInsuranceProviderSpan"
			>Switch provider</span
		>
		<app-title-insurance-toolbar
			[provider]="titleInsurance?.provider"
			[orderValid]="orderValid"
			[status]="state"
			[hasQuote]="hasQuote"
			(cancelOrder)="cancel()"
			(openModal)="openModal()"
		></app-title-insurance-toolbar>
		<app-missing-fields-notif
			*ngIf="state && !orderValid && !isCommercial && !invalidProperty"
			[missing]="missing"
		></app-missing-fields-notif>
	</div>
</div>

<div class="flex gap-2 items-center justify-between mt-1">
	<hr class="w-5/12 mt-2" />
	<p class="text-lg font-bold text-center">Order summary</p>
	<hr class="w-5/12 mt-2" />
</div>

<div
	*ngIf="currentStep !== 0 || titleInsurance?.thirdPartyId"
	class="flex gap-2 justify-center items-center mt-3"
>
	<div class="border-r border-grey-veryLight pr-2">
		<p>
			<span class="text-gray">Order number: </span>
			<span class="font-bold"> {{ titleInsurance?.thirdPartyId }} </span>
		</p>
	</div>
	<div
		class="border-r border-grey-veryLight pr-2"
		*ngIf="titleInsurance?.orderedOn"
	>
		<p>
			<span class="text-gray">Order date: </span>
			<span class="font-bold">
				{{ titleInsurance?.orderedOn | date: 'mediumDate' }}
			</span>
		</p>
	</div>
	<div *ngIf="effectiveDate$ | async">
		<p>
			<span class="text-gray">Effective date: </span>
			<span class="font-bold">
				{{ effectiveDate$ | async | date: 'mediumDate' }}
			</span>
		</p>
	</div>
</div>

<div *ngIf="currentStep !== 2" class="flex mt-10 justify-center mx-4">
	<app-step-progress-nav
		class="stepper"
		[steps]="steps"
		[current]="currentStep"
		[testHook]="testHooks.StepProgressNav"
	></app-step-progress-nav>
</div>

<div *ngIf="loading" class="flex flex-1 flex-col justify-center items-center">
	<div class="mt-10 flex items-center">
		<app-icon
			[icon]="ICON.LOADING"
			class="text-7xl mr-3 text-grey"
			[spin]="true"
			[testHook]="testHooks.LoadingIcon"
		></app-icon>
		<h4 class="text-grey">
			<span>Loading</span>
		</h4>
	</div>
</div>

<div class="mt-10" *ngIf="!loading">
	<app-fct-not-submitted
		*ngIf="currentStep === 0 || !orderValid"
		(openModal)="openModal()"
		(cancelOrder)="cancel()"
		[orderValid]="orderValid"
		[missing]="missing"
		[isCommercial]="isCommercial"
		[invalidProperty]="invalidProperty"
		[outOfOntario]="outOfOntario"
	></app-fct-not-submitted>
	<app-fct-in-progress
		*ngIf="currentStep === 1 && orderValid"
		(openModal)="openModal()"
		(cancelOrder)="cancel()"
	></app-fct-in-progress>
	<app-fct-completed
		*ngIf="currentStep === 2 && orderValid"
		(openModal)="openModal()"
	></app-fct-completed>
</div>
